import ReportLayout from "./report-layout";

export default ReportLayout